import { SelectableStudentLists, StudentGroup } from '../models/Assignment';

/** Listed in the order the sidebar renders its tabs, so the reported array is deterministic. */
const STUDENT_GROUPS_IN_TAB_ORDER = [
  { key: 'readyToLearn', group: 'on_track' },
  { key: 'buildingFoundations', group: 'paving_the_way' },
  { key: 'alreadyMastered', group: 'already_passed' },
] as const;

/**
 * The tabs the teacher actually assigned to: a group counts only when at least one of its students
 * is still checked. A tab with no students, or one the teacher unchecked entirely, is left out.
 */
export const getSelectedStudentGroups = (studentsLists: SelectableStudentLists): StudentGroup[] =>
  STUDENT_GROUPS_IN_TAB_ORDER.filter(({ key }) => studentsLists[key].list.some(student => student.selected)).map(
    ({ group }) => group,
  );
